// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_UseResizeObserver = require("./Expln_React_UseResizeObserver.res.js");

function Expln_React_ContentWithStickyHeader(props) {
  var __top = props.top;
  var top = __top !== undefined ? __top : 0;
  var match = React.useState(function () {
        return top;
      });
  var setContentTop = match[1];
  var headerRef = React.useRef(null);
  Expln_React_UseResizeObserver.useClientSizeObserver(headerRef, (function (param, headerHeight) {
          setContentTop(function (param) {
                return top + headerHeight | 0;
              });
        }));
  return React.createElement(React.Fragment, {}, React.createElement("div", {
                  ref: Caml_option.some(headerRef),
                  style: {
                    background: "white",
                    position: "sticky",
                    top: String(top) + "px",
                    zIndex: "1000"
                  }
                }, props.header), props.content(match[0]));
}

var make = Expln_React_ContentWithStickyHeader;

exports.make = make;
/* react Not a pure module */
